import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.sort.js";
let _ = (t)=>t, t;
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { css } from '@emotion/react';
import RichTextMarkdown from 'components/richTextMarkdown/RichTextMarkdown';
import { BottomSheet, Box, ChevronDownIcon, Dropdown, useBreakpoints, useTheme } from 'fabric';
import SortingRadioOptions from 'features/searchCompare/modules/productDetailOffers/filters/components/SortingRadioOptions';
import { useProductDetailOffersFilters } from 'features/searchCompare/modules/productDetailOffers/filters/useProductDetailOffersFilters';
import { getFeatureFlag } from 'globalStorage/settingsStore';
import { useState } from 'react';
import { useTranslate } from 'utils/Translate';
import { QuickFilterButton } from './QuickFilterButton';
const SortingRankInfo = ()=>{
    const translate = useTranslate();
    const theme = useTheme();
    return /*#__PURE__*/ _jsx(RichTextMarkdown, {
        source: translate('PR.ProductPage.RANK_INFO'),
        sx: css(t || (t = _`
        p,
        a {
          font-size: ${0};
          color: ${0};
          margin-top: ${0}px;
        }
        a:hover,
        a:visited {
          color: ${0};
        }
      `), theme.textSize.s, theme.color.textSecondary, theme.space.m, theme.color.textSecondary)
    });
};
export const SortingQuickFilter = ({ alignRight = true })=>{
    const translate = useTranslate();
    const { optimisticFilters } = useProductDetailOffersFilters();
    const [isOpen, setIsOpen] = useState(false);
    const breakpoints = useBreakpoints();
    const getSortingLabel = (sorting)=>{
        return translate(`PR.ProductPage.FilterModal.Sorting.${sorting}`);
    };
    var _optimisticFilters_sort;
    const button = /*#__PURE__*/ _jsx(QuickFilterButton, {
        icon: /*#__PURE__*/ _jsx(ChevronDownIcon, {}),
        iconPosition: "right",
        onClick: ()=>{
            setIsOpen(true);
        },
        children: getSortingLabel((_optimisticFilters_sort = optimisticFilters.sort) !== null && _optimisticFilters_sort !== void 0 ? _optimisticFilters_sort : 'PRICE')
    });
    return breakpoints.l ? /*#__PURE__*/ _jsx(Dropdown, {
        alignRight: alignRight,
        open: isOpen,
        sx: {
            borderRadius: 12
        },
        toggleElement: button,
        onClose: ()=>setIsOpen(false),
        children: /*#__PURE__*/ _jsxs(Box, {
            padding: "m",
            children: [
                /*#__PURE__*/ _jsx(SortingRadioOptions, {
                    onChange: ()=>setIsOpen(false)
                }),
                getFeatureFlag('show_search_legal_info') && /*#__PURE__*/ _jsx(SortingRankInfo, {})
            ]
        })
    }) : /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            button,
            /*#__PURE__*/ _jsxs(BottomSheet, {
                open: isOpen,
                onClose: ()=>setIsOpen(false),
                children: [
                    /*#__PURE__*/ _jsx(BottomSheet.Header, {
                        title: translate('PR.ProductPage.FilterModal.HEADING_SORTING')
                    }),
                    /*#__PURE__*/ _jsxs(BottomSheet.Body, {
                        children: [
                            /*#__PURE__*/ _jsx(SortingRadioOptions, {
                                onChange: ()=>setIsOpen(false)
                            }),
                            getFeatureFlag('show_search_legal_info') && /*#__PURE__*/ _jsx(SortingRankInfo, {})
                        ]
                    })
                ]
            })
        ]
    });
};
